import {useEffect} from "react";

import {checkIfNeedToUpdateMatchAll} from "../../../../../misc/helperHooks";

import {
  getCurrentGroups,
  getCurrentWizardNavItems,
  getFeatureGroupFromWizardGroup, getNextWizardStepQuantity,
} from "./lookWizardFunctions";
import {useAppSelector} from "../../../../../storeHooks";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";


export const useLookWizardStepChanges = ({
                                           wizardShowFeatureSection,
                                           setWizardShowFeatureSection,
                                           wizardSelectedValues,
                                           setWizardSelectedValues,
                                           wizardActiveStep,
                                           setWizardActiveStep,
                                           wizardActiveItem,
                                           wizardSqftCartItems,
                                           setGroheActiveFeatureQuantity,
                                         }) => {

  const {navigationCount} = useAppSelector(state => state.lookState);

  useEffect(() => {
    if (wizardShowFeatureSection) {
      setWizardShowFeatureSection(false);
    }

    if (wizardActiveStep > -1) {
      const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

      setGroheActiveFeatureQuantity(getNextWizardStepQuantity(currentGroups, wizardSelectedValues, wizardActiveStep, null, wizardSqftCartItems));

      if (currentGroups.length === 1) {
        const wizardGroup = currentGroups[0];
        const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);

        if (featureGroup && featureGroup.activeFeature) {
          checkIfNeedToUpdateMatchAll(featureGroup, wizardGroup);
        }

        if (!featureGroup || wizardSelectedValues[wizardActiveStep]) {
          return
        }

        const navItems = wizardActiveItem
          ? getCurrentWizardNavItems(wizardSelectedValues, wizardActiveStep, wizardActiveItem, wizardGroup, featureGroup)
          : [];

        // console.log("wizardGroup", wizardGroup);
        if (!navItems.length && featureGroup.getRealFeaturesReceivedProperty()) {
          setWizardSelectedValues({
            [wizardActiveStep]: {
              wizardGroup,
            }
          });
          setWizardActiveStep(wizardActiveStep + 1); // skip this wizard step
        } else if (wizardGroup.useIncluded && Array.isArray(wizardGroup.featuresIncluded) && (wizardGroup.featuresIncluded.length === 1)) {
          if (navItems.length === 1 && IS_PRODUCT_JOURNEY) {
            console.log("setWizardSelectedValues auto feature", navItems[0]);
            const quantity = getNextWizardStepQuantity(currentGroups, wizardSelectedValues, wizardActiveStep,  navItems[0].part, wizardSqftCartItems);
            setWizardSelectedValues({
              [wizardActiveStep]: {
                wizardGroup,
                selectedFeature: navItems[0].part,
                partId: featureGroup.partId,
                singleFeature: true,
                quantity,
                quantityItems: [{quanFeature: navItems[0].part, quantity}],
              }
            });
            setGroheActiveFeatureQuantity(quantity);
          }
        } else if (wizardSqftCartItems && wizardSqftCartItems.length) {
          const selectedInSqft = wizardSqftCartItems.filter(cItem => {
            return cItem.cartFeature && cItem.cartFeature.dbFeature.groupName === (featureGroup.dbName || featureGroup.partName)
          });
          if (selectedInSqft.length) {
            const canSelectNavItem = navItems.find(navItem => {
              return selectedInSqft.some(cItem => {
                return cItem.cartFeature
                  && (cItem.cartFeature.dbFeature.sharedFeatureName === navItem.part.dbFeature.sharedFeatureName)
              })
            });
            console.log("selectedInSqft navItem", canSelectNavItem);
            if (canSelectNavItem) {
              setWizardSelectedValues({
                [wizardActiveStep]: {
                  wizardGroup,
                  selectedFeature: canSelectNavItem.part,
                  partId: featureGroup.partId,
                }
              });
            }
          }
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep, navigationCount])

  return null
}
